import { useJobFunctions } from '@/api/useJobFunctions';

/**
 * This component will preload SWR api backend calls.
 *
 * Preload api calls for most frequently visited page.
 * Can block app from rendering for crucial backend call with care.
 */
const PreloadApi = ({ children }: React.PropsWithChildren) => {
    useJobFunctions();

    return children;
};

export default PreloadApi;
